import { useEffect, useRef, useState } from "react";
import { Calendar, MapPin, X } from "lucide-react";
import Stepper from "./stepper";
// import { getSourceLead, getUsers } from "../../utils/firebasefunctions";
import PropertyTypePopup from "../PropertyTypePopup";
import DealStagePopup from "../DealStagePopup";
// import PriorityPopup from "../PriorityPopup";
import ClientTypePopup from "../ClientTypePopup";
import { useStateValue } from "../../context/StateProvider";
import UserPopUp from "../UserPopUp";
import LeadSourcePopup from "../LeadSourcePopup";
import SplitTypePopup from "../SplitTypePopup";
import CapTypePopUp from "../CapTypePopUp";
import { FaPlus } from "react-icons/fa6";
import { AiFillMinusCircle } from "react-icons/ai";
import { Pencil, Trash2 } from "lucide-react";
import FinancingTypPopup from "../FinancingTypePopup";
import InspectionPopup from "../inspectionPopup";
import {
  Autocomplete,
  LoadScript,
  useLoadScript,
} from "@react-google-maps/api";
import moment from "moment";
import {
  asNumber,
  formatCurrency,
  formatDate,
  formatNumber,
  removeCommas,
  stripCountry,
} from "../../utils/helper";
import { IoRadioButtonOff, IoRadioButtonOn } from "react-icons/io5";
import { isBookableTeamLead } from "../../utils/roles";
import TitleVendorPicker from "./title-vendor-picker";
import { listenVendors, addVendor } from "../../utils/vendorDirectory";
import { a } from "framer-motion/client";
import ClientSuggesstionPopup from "../ClientSuggesstionPopup";
import AddClientPicker from "../new-contact/AddClientPicker";
import ContactEditDrawer from "../new-contact/ContactEditDrawer";
import { normalizeContact } from "../../utils/contactNormalize";
import { addContact, updateContact } from "../../utils/contactsApi";
import {
  getContactsForUser,
  getContactsByIds,
} from "../../utils/firebasefunctions";
import { toast } from "react-toastify";
import ImportFromPDFButton from "../deals/ImportFromPDF";
import AttachPurchaseAgreement from "../deals/AttachPurchaseAgreement";
import { geocodeAddress } from "../../utils/parsePurchaseAgreement";
const libraries = ["places"];

const AddNewDeal = ({
  onClose,
  onSubmit,
  steps,
  editdata,
  seed,
  isLoading,
  isStatus,
}) => {
  const [{ employees, teamleads, leadsource, user, deals, teamDefaults }, dispatch] =
    useStateValue();

  const [currentStep, setCurrentStep] = useState(1);
  const [splitType, setSplitType] = useState("");
  // PDF-import panel state lifted out of ImportFromPDFButton so it survives
  // step-1 unmount/remount when the user navigates between steps.
  const [pdfImportState, setPdfImportState] = useState(null);

  // Purchase-agreement PDF attached for upload to Drive on submit. Held as
  // a File ref in JS heap — survives step navigation (modal stays mounted)
  // but not full-page reload (acceptable; agent re-attaches).
  const [attachedPaFile, setAttachedPaFile] = useState(null);
  const [paFileAutoAttached, setPaFileAutoAttached] = useState(false);

  const [dragActive, setDragActive] = useState(false);
  const [sourceData, setSourceData] = useState([]);
  const [confirm, setconfirm] = useState(true);
  const [propertytypepopup, setpropertytypepopup] = useState(false);
  const [dealstagepopup, setdealstagepopup] = useState(false);
  const [inspectionPopup, setinspection] = useState(false);
  const [financingTypepopup, setfinancingTypepopup] = useState(false);
  // const [prioritypopup, setprioritypopup] = useState(false);
  const [buyertypepopup, setbuyertypepopup] = useState(false);
  const [teamleadpopup, setteamleadpopup] = useState(false);
  const [agentpopup, setagentpopup] = useState(false);
  const [leadpopup, setleadpopup] = useState(false);
  const [splitpopup, setsplitpopup] = useState(false);
  const [cappopup, setcappopup] = useState(false);
  const [paidtobank, setpaidtobank] = useState(0);
  const [clientpopup, setclientpopup] = useState(false);
  const [clientfieldfocus, setclientfieldfocus] = useState("");
  const [clientindexfocus, setclientindexfocus] = useState(0);
  const autoCompleteRef = useRef(null);
  const [contactSyncData, setContactSyncData] = useState([]);
  const [dealContactsData, setDealContactsData] = useState([]);
  // New client picker / edit drawer state (same UX as List/Buyer Request)
  const [pickerOpen, setPickerOpen] = useState(false);
  const [editingContact, setEditingContact] = useState(null);
  const [creatingContact, setCreatingContact] = useState(false);
  const [contactSaving, setContactSaving] = useState(false);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyClMaFJLo3buNYK-siytTa6AWD_72TgrE8",
    libraries,
  });

  const [formData, setFormData] = useState({
    step1: {},
    step2: {},
    step3: {},
    step4: {},
  });

  const [step1Data, setStep1Data] = useState({
    mlsNumber: "",
    propertyType: "",
    // listingPrice: 0,
    earnestMoney: 0,
    offerPrice: 0,
    dealStage: "",
    inspection: "",
    // Priority: "",
    financingType: "",
    propertyaddress: "",
    // Blank, never today. A closing date is a contract term — see
    // buildTurnInSeed for why guessing one is never harmless.
    closingdate: "",
    financingDeadline: "",
    inspectionDeadline: "",
    propertyphoto: "",
    propertyphotodata: "",
    titleCompany: "",
    titleCloserName: "",
    titleCloserEmail: "",
    titleCloserPhone: "",
    otherTitleCompany: "",
    otherTitleCloserName: "",
    otherTitleCloserEmail: "",
    otherTitleCloserPhone: "",
    notes: "",
  });

  // Step 2 inputs
  const [step2Data, setStep2Data] = useState({
    clientType: "",
    clientinfo: [""],
  });

  const [step3Data, setStep3Data] = useState({
    teamleadName: "",

    assignedteamlead: "",
    agentName:
      user.role == "Employee" ? user.firstname + " " + user.lastname : "",
    agentid: user.role == "Employee" ? user.id : "",
    leadsource: "",
    propertyAddress: "",
    agentCommission: 0,
    thirdpartyagentCommission: 0,
    thirdpartyagentName: "",
    fixedagentcommission: false,
    leadCommission: 0,
    splittype: user.role == "Employee" ? "TeamSplit" : "",
    inhousereferral: false,
    splitdescription: user.role == "Employee" ? "Team Member Split" : "",
    brokeradminfee: 0,
    captype: "pre",
    captypedescription: "Pre-Cap (90/10 Split)",
  });

  const [step4Data, setstep4Data] = useState({
    flatfee: false,
    flatfeeamount: 0,
    totalcommissionrate: 3.3,
    buyersidecommissionrate: "",
    sellersidecommissionrate: "",
    teamleadcommissionrate: "",
    agentCommissionamount: 0,
    teamleaddiscount: 0,
    agentdiscount: 0,
    leadsourceCommissionamount: 0,
    teamleadCommissionamount: 0,
    totalCommissionamount: 0,
    bankcommission: 0,
    thirdpartyagentcommissionamount: 0,
    takehomecommissionamount: 0,
  });

  const hiddenDateRef = useRef(null);
  const hiddenDateRef2 = useRef(null);
  const hiddenDateRef3 = useRef(null);
  const [titleVendors, setTitleVendors] = useState([]);
  const titleSeededRef = useRef(false);

  // Pre-fill title info from the team default on a fresh turn-in (not editing).
  // Seeds once, and only fields the user hasn't already typed into.
  useEffect(() => {
    if (editdata) return;
    if (titleSeededRef.current) return;
    if (!teamDefaults) return;
    titleSeededRef.current = true;
    setStep1Data((prev) => ({
      ...prev,
      titleCompany: prev.titleCompany || teamDefaults.titleCompany || "",
      titleCloserName:
        prev.titleCloserName || teamDefaults.titleCloserName || "",
      titleCloserEmail:
        prev.titleCloserEmail || teamDefaults.titleCloserEmail || "",
      titleCloserPhone:
        prev.titleCloserPhone || teamDefaults.titleCloserPhone || "",
    }));
  }, [teamDefaults, editdata]);

  // The turn-in title dropdowns pull the team's preferred TITLE vendors from the
  // shared Vendor Directory (category "Title"). "Add new" adds there too, so the
  // directory stays the single source of "who we prefer to use".
  useEffect(() => {
    const unsub = listenVendors((rows) => {
      setTitleVendors(
        rows
          .filter((v) => (v.category || "").toLowerCase() === "title")
          .map((v) => ({
            id: v.id,
            company: v.company || "",
            officerName: v.name || "",
            email: v.email || "",
            phone: v.phone || "",
          })),
      );
    });
    return () => unsub && unsub();
  }, []);

  const handleAddTitleVendor = async (vendor) => {
    try {
      await addVendor(
        {
          category: "Title",
          company: vendor.company || "",
          name: vendor.officerName || "",
          email: vendor.email || "",
          phone: vendor.phone || "",
        },
        user?.id,
      );
    } catch (err) {
      console.error("addVendor failed:", err);
    }
  };

  const handlePlaceChanged = () => {
    const place = autoCompleteRef.current.getPlace();

    if (!place.geometry) return;

    setStep1Data({
      ...step1Data,
      propertyaddress: stripCountry(place.formatted_address),
      propertyLocation: {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      },
    });
  };

  useEffect(() => {
    const fetchContacts = async () => {
      console.log("Fetching contacts...");
      const userContacts = await getContactsForUser(user);
      setContactSyncData(userContacts);
    };

    if (user?.id) {
      fetchContacts();
    }
  }, [user?.id, user]);

  useEffect(() => {
    const fetchDealContacts = async () => {
      const validIds = step2Data.clientinfo.filter((id) => id !== "");
      if (!validIds.length) {
        setDealContactsData([]);
        return;
      }
      const contacts = await getContactsByIds(validIds);
      setDealContactsData(contacts);
    };

    fetchDealContacts();
  }, [step2Data.clientinfo]);
  const handleParsedFields = async (fields) => {
    setStep1Data((prev) => ({
      ...prev,
      ...(fields.offerPrice != null && { offerPrice: fields.offerPrice }),
      ...(fields.earnestMoney != null && { earnestMoney: fields.earnestMoney }),
      ...(fields.closingdate != null && { closingdate: fields.closingdate }),
      ...(fields.propertyaddress != null && {
        propertyaddress: fields.propertyaddress,
      }),
      ...(fields.financingType != null && {
        financingType: fields.financingType,
      }),
      ...(fields.financingDeadline != null && {
        financingDeadline: fields.financingDeadline,
      }),
      ...(fields.inspection != null && { inspection: fields.inspection }),
      ...(fields.inspectionDeadline != null && {
        inspectionDeadline: fields.inspectionDeadline,
      }),
    }));

    if (fields.propertyaddress) {
      const loc = await geocodeAddress(fields.propertyaddress);
      if (loc) {
        setStep1Data((prev) => ({ ...prev, propertyLocation: loc }));
      } else {
        toast.warn(
          "Couldn't determine map location for the imported address. Please verify.",
        );
      }
    }
  };

  useEffect(() => {
    if (editdata) {
      console.log("editdata", editdata);

      setStep1Data({
        // mlsNumber: editdata.mlsNumber,
        propertyType: editdata.propertyType,
        // listingPrice: editdata.listingPrice,
        earnestMoney: editdata.earnestMoney,
        offerPrice: editdata.offerPrice,
        dealStage: editdata.dealStage,
        inspection: editdata.inspection,
        financingType: editdata.financingType,
        // Priority: editdata.priority,
        propertyaddress: editdata.propertyaddress,
        // A deal with no closing date keeps having no closing date. Opening
        // and saving it must never invent one.
        closingdate: editdata.closingdate || "",
        inspectionDeadline: editdata.inspectionDeadline,
        financingDeadline: editdata.financingDeadline,
        propertyphoto: editdata.propertyphoto,
        propertyphotodata: editdata.propertyphoto,
        propertyphotofiles: editdata.propertyphoto,
        propertyLocation: editdata.propertyLocation,
        titleCompany: editdata.titleCompany || "",
        titleCloserName: editdata.titleCloserName || "",
        titleCloserEmail: editdata.titleCloserEmail || "",
        titleCloserPhone: editdata.titleCloserPhone || "",
        otherTitleCompany: editdata.otherTitleCompany || "",
        otherTitleCloserName: editdata.otherTitleCloserName || "",
        otherTitleCloserEmail: editdata.otherTitleCloserEmail || "",
        otherTitleCloserPhone: editdata.otherTitleCloserPhone || "",
        notes: editdata.notes || "",
      });

      setStep2Data({
        clientType: editdata.dealtype,
        clientinfo: editdata.customers || [""],
      });

      const agent = employees.find((data) => data.id === editdata.createdby);

      setStep3Data({
        ...step3Data,
        assignedteamlead: editdata.assignedteamlead,
        teamleadName: editdata.teamleadName,
        leadsource: editdata.leadsource,
        leadCommission: editdata.leadCommission,
        agentName: editdata.agentName,
        agentid: editdata.agentData, // string me convert
        agentCommission: editdata.agentCommission,
        fixedagentcommission: editdata?.fixedagentcommission || false,
        splittype: editdata.splittype,
        inhousereferral: editdata?.inhousereferral || false,
        splitdescription: editdata.splitdescription,
        thirdpartyagentName: editdata.thirdpartyagentName,
        thirdpartyagentCommission: editdata.thirdpartyagentCommission,
        brokeradminfee: editdata.brokeradminfee,
        captype: editdata.captype,
        captypedescription: editdata.captypedescription,
      });

      setstep4Data({
        ...step4Data,
        flatfee: editdata.flatfee || false,
        flatfeeamount: editdata.flatfeeamount || 0,
        teamleaddiscount: editdata.teamleaddiscount || 0,
        agentdiscount: editdata.agentdiscount || 0,
        totalcommissionrate: editdata.totalcommissionrate,
      });
    }
  }, [editdata]);

  // When opened as a Sale Turn-In with a picked source, seed the four step
  // states from the source's data. Runs when `seed` becomes non-null.
  // `editdata` wins if both are present (defensive — shouldn't happen).
  useEffect(() => {
    if (editdata) return;
    if (!seed) return;
    setStep1Data((prev) => ({ ...prev, ...seed.step1 }));
    setStep2Data((prev) => ({ ...prev, ...seed.step2 }));
    setStep3Data((prev) => ({ ...prev, ...seed.step3 }));
    setstep4Data((prev) => ({ ...prev, ...seed.step4 }));
  }, [seed, editdata]);

  // Fields the agent has touched since the seed populated them. Used to
  // remove the "From listing"/"From buyer request" decoration once edited.
  const [editedSinceSeed, setEditedSinceSeed] = useState({});
  const markEdited = (key) =>
    setEditedSinceSeed((prev) => (prev[key] ? prev : { ...prev, [key]: true }));
  // Prefill decoration ("From buyer request"/"From listing" tag + amber edge)
  // disabled per request — the seed still fills the fields, just without the tag.
  const isPrefilled = () => false;
  // eslint-disable-next-line no-unused-vars
  const _keepEditedSeed = editedSinceSeed;
  const seedSourceLabel =
    seed?.source === "buyer" ? "From buyer request" : "From listing";

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const data = calculatecommission();
      setstep4Data(data);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [
    step1Data.offerPrice,
    step3Data.leadCommission,
    step3Data.captype,
    step3Data.agentCommission,
    step3Data.fixedagentcommission,
    step3Data.agentid,
    step3Data.thirdpartyagentCommission,
    step3Data.splittype,
    step4Data.totalcommissionrate,
    step4Data.flatfee,
    step4Data.flatfeeamount,
    step4Data.teamleaddiscount,
    step4Data.agentdiscount,
  ]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const closedDeals = deals?.filter(
      (deal) =>
        deal?.dealStage === "Closed" &&
        deal?.status === "Approved" &&
        new Date(deal?.closingdate).getFullYear() === currentYear,
    );

    const pendingDeals = deals?.filter(
      (deal) =>
        deal.dealStage.toLowerCase() != "closed" &&
        deal.dealStage.toLowerCase() != "cancelled" &&
        deal.dealStage.toLowerCase() != "expired" &&
        new Date(deal?.closingdate).getFullYear() === currentYear,
    );

    const totalbrokarCommission = closedDeals?.reduce(
      (sum, deal) => sum + Number(deal?.bankcommission || 0),
      0,
    );

    const totalPendingbrokarCommission = pendingDeals?.reduce(
      (sum, deal) => sum + Number(deal?.bankcommission || 0),
      0,
    );

    const totaladminfee = closedDeals?.reduce(
      (sum, deal) => sum + Number(deal?.brokeradminfee || 0),
      0,
    );

    const totalpendingadminfee = pendingDeals?.reduce(
      (sum, deal) => sum + Number(deal?.brokeradminfee || 0),
      0,
    );

    let totalfeespaidtobank =
      totalpendingadminfee +
      totaladminfee +
      totalPendingbrokarCommission +
      totalbrokarCommission;
    setpaidtobank(totalfeespaidtobank);
    if (!editdata && totalfeespaidtobank > 70000) {
      let newstep3data = { ...step3Data };
      newstep3data.captype = "post";
      newstep3data.captypedescription = "Post-Cap (100% Commission)";
      setStep3Data(newstep3data);
    }
  }, []);

  useEffect(() => {
    if (isStatus && step1Data.dealStage !== isStatus) {
      // Moving a deal to Closed sets the STAGE only. It used to also stamp
      // today into a blank closing date (in DD-MM-YYYY, which the rest of the
      // app reads as YYYY-MM-DD) — a guessed date in a corrupt format.
      setStep1Data({
        ...step1Data,
        dealStage: isStatus,
      });
    }
  }, [isStatus, step1Data.dealStage]);

  const calculatecommission = (agentcasestep4data) => {
    let data = agentcasestep4data
      ? { ...agentcasestep4data }
      : { ...step4Data };
    data.totalCommissionamount = step4Data.flatfee
      ? step4Data.flatfeeamount != ""
        ? parseFloat(step4Data.flatfeeamount)
        : 0
      : (step1Data.offerPrice / 100) *
        (asNumber(data.totalcommissionrate));

    data.totalCommissionamount = data.totalCommissionamount?.toFixed(2);

    if (step3Data.captype == "pre") {
      if (step3Data.splittype === "Referral") {
        if (step3Data.leadCommission > 0) {
          let thirdpartcommission = (
            (data.totalCommissionamount / 100) *
            asNumber(step3Data.thirdpartyagentCommission)
          ).toFixed(2);
          let leadcommission = (
            (data.totalCommissionamount / 100) *
            asNumber(step3Data.leadCommission)
          ).toFixed(2);
          let takehomecommission =
            data.totalCommissionamount - thirdpartcommission - leadcommission;

          data.bankcommission = ((takehomecommission / 100) * 10).toFixed(2);

          // data.takehomecommissionamount =  takehomecommission - data.bankcommission;
          data.takehomecommissionamount =
            employees.find((emp) => emp.id == step3Data.agentid)?.role ==
            "Employee"
              ? takehomecommission
              : takehomecommission - data.bankcommission;
        } else {
          let thirdpartcommission = (
            (data.totalCommissionamount / 100) *
            asNumber(step3Data.thirdpartyagentCommission)
          ).toFixed(2);
          let takehomecommission =
            data.totalCommissionamount - thirdpartcommission;

          data.bankcommission = ((takehomecommission / 100) * 10).toFixed(2);
          // data.takehomecommissionamount =
          //   takehomecommission - data.bankcommission;
          // data.takehomecommissionamount = takehomecommission;
          data.takehomecommissionamount =
            employees.find((emp) => emp.id == step3Data.agentid)?.role ==
            "Employee"
              ? takehomecommission
              : takehomecommission - data.bankcommission;
        }
      } else {
        if (step3Data.leadCommission > 0) {
          let leadcommission = (
            (data.totalCommissionamount / 100) *
            asNumber(step3Data.leadCommission)
          ).toFixed(2);
          let takehomecommission = data.totalCommissionamount - leadcommission;

          data.bankcommission = ((takehomecommission / 100) * 10).toFixed(2);
          // data.takehomecommissionamount =
          //   takehomecommission - data.bankcommission;
          // data.takehomecommissionamount = takehomecommission;
          data.takehomecommissionamount =
            employees.find((emp) => emp.id == step3Data.agentid)?.role ==
            "Employee"
              ? takehomecommission
              : takehomecommission - data.bankcommission;
        } else {
          data.bankcommission = (
            (data.totalCommissionamount / 100) *
            10
          ).toFixed(2);
          // data.takehomecommissionamount = data.totalCommissionamount;
          data.takehomecommissionamount =
            employees.find((emp) => emp.id == step3Data.agentid)?.role ==
            "Employee"
              ? data.totalCommissionamount
              : data.totalCommissionamount - data.bankcommission;
        }
      }
    } else {
      data.bankcommission = 0;

      if (step3Data.splittype === "Referral") {
        if (step3Data.leadCommission > 0) {
          let thirdpartcommission = (
            (data.totalCommissionamount / 100) *
            asNumber(step3Data.thirdpartyagentCommission)
          ).toFixed(2);
          let leadcommission = (
            (data.totalCommissionamount / 100) *
            asNumber(step3Data.leadCommission)
          ).toFixed(2);
          let takehomecommission =
            data.totalCommissionamount - thirdpartcommission - leadcommission;

          data.takehomecommissionamount = takehomecommission;
        } else {
          let thirdpartcommission = (
            (data.totalCommissionamount / 100) *
            asNumber(step3Data.thirdpartyagentCommission)
          ).toFixed(2);
          let takehomecommission =
            data.totalCommissionamount - thirdpartcommission;

          data.takehomecommissionamount = takehomecommission;
        }
      } else {
        if (step3Data.leadCommission > 0) {
          let leadcommission = (
            (data.totalCommissionamount / 100) *
            asNumber(step3Data.leadCommission)
          ).toFixed(2);
          let takehomecommission = data.totalCommissionamount - leadcommission;

          data.takehomecommissionamount = takehomecommission;
        } else {
          data.takehomecommissionamount =
            (step1Data.offerPrice / 100) * asNumber(data.totalcommissionrate);
        }
      }
    }
    return data;
  };

  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);

    const previewUrls = files.map((file) => URL.createObjectURL(file));

    setStep1Data({
      ...step1Data,
      propertyphoto: previewUrls, // Preview ke liye
      propertyphotofiles: files, // <-- REAL FILES FOR UPLOAD
    });
  };

  const openDatePicker = () => {
    hiddenDateRef.current.showPicker(); // modern browsers
  };

  const openDatePicker2 = () => {
    hiddenDateRef2.current.showPicker(); // modern browsers
  };

  const openDatePicker3 = () => {
    hiddenDateRef3.current.showPicker(); // modern browsers
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    const files = Array.from(e.dataTransfer.files);

    const previewUrls = files.map((file) => URL.createObjectURL(file));

    setStep1Data({
      ...step1Data,
      propertyphoto: previewUrls,
      propertyphotofiles: files, // <-- REAL FILES FOR UPLOAD
    });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleStepClick = (stepNumber) => {
    return;
    setCurrentStep(stepNumber);
  };

  const getContactById = (id) => {
    return (
      dealContactsData.find((c) => c.id === id) ||
      contactSyncData.find((c) => c.id === id) ||
      {}
    );
  };

  // Attach an already-existing contact to this deal (or reuse the first
  // empty slot in clientinfo from legacy state).
  const attachClient = (contactId) => {
    setStep2Data((prev) => {
      const arr = [...prev.clientinfo];
      if (arr.includes(contactId)) {
        toast.info("That client is already added");
        return prev;
      }
      const emptyIdx = arr.findIndex((id) => !id);
      if (emptyIdx >= 0) arr[emptyIdx] = contactId;
      else arr.push(contactId);
      return { ...prev, clientinfo: arr };
    });
  };

  const handleEditClient = (rawContact) => {
    setEditingContact(normalizeContact(rawContact));
  };

  const handleSaveEditedContact = async (form) => {
    setContactSaving(true);
    try {
      const result = await updateContact({
        user,
        contact: editingContact,
        form,
      });
      const patch = (c) =>
        c?.id === editingContact.id ? { ...c, ...result } : c;
      setDealContactsData((prev) => prev.map(patch));
      setContactSyncData((prev) => prev.map(patch));
      toast.success("Client updated");
      setEditingContact(null);
    } catch (err) {
      console.error("Client save failed:", err);
      toast.error(err.message || "Save failed");
    } finally {
      setContactSaving(false);
    }
  };

  const handleCreateNewContact = async (form) => {
    setContactSaving(true);
    try {
      if (!user?.gmailtoken?.access_token) {
        toast.error("Connect Gmail in Settings before adding a new contact");
        return;
      }
      const created = await addContact({ user, contact: form });
      setContactSyncData((prev) => [
        { ...created, id: created.firebaseId, createdBy: user.id },
        ...prev,
      ]);
      attachClient(created.firebaseId);
      toast.success("Client added");
      setCreatingContact(false);
    } catch (err) {
      console.error("Create contact failed:", err);
      toast.error(err.message || "Create failed");
    } finally {
      setContactSaving(false);
    }
  };

  const handleNext = () => {
    // Save current step data before moving forward
    if (currentStep === 1) {
      setFormData((prev) => ({ ...prev, step1: step1Data }));
    } else if (currentStep === 2) {
      // Client type drives which form (Buyer vs Seller) and commission are
      // used downstream, so it must be chosen before continuing.
      if (!step2Data.clientType) {
        toast.error("Please select Buyer or Seller before continuing");
        return;
      }
      setFormData((prev) => ({ ...prev, step2: step2Data }));
    } else if (currentStep === 3) {
      setFormData((prev) => ({ ...prev, step3: step3Data }));
    } else if (currentStep === 4) {
      let newdata = { ...step4Data };

      /////////////lead source commission/////
      newdata.leadsourceCommissionamount = (
        (step4Data.totalCommissionamount / 100) *
        asNumber(step3Data.leadCommission)
      ).toFixed(2);

      /////////////team lead commission/////

      newdata.teamleadCommissionamount =
        step3Data.captype == "pre"
          ? (
              (step4Data.takehomecommissionamount / 100) *
              (employees.find((emp) => emp.id == step3Data.agentid)?.role ==
              "Employee"
                ? 100 -
                  (!step3Data.fixedagentcommission
                    ? asNumber(step3Data.agentCommission)
                    : 0) -
                  10
                : 100 -
                  (!step3Data.fixedagentcommission
                    ? asNumber(step3Data.agentCommission)
                    : 0))
            ).toFixed(2)
          : (
              (step4Data.takehomecommissionamount / 100) *
              (100 -
                (!step3Data.fixedagentcommission
                  ? asNumber(step3Data.agentCommission)
                  : 0))
            ).toFixed(2);
      newdata.teamleadCommissionamount =
        newdata.teamleadCommissionamount -
        (step3Data.fixedagentcommission ? asNumber(step3Data.agentCommission) : 0);
      // newdata.teamleadCommissionamount =
      //   step3Data.captype == "pre"
      //     ? (step4Data.takehomecommissionamount / 100) *
      //       (100 - step3Data.agentCommission - 10).toFixed(2)
      //     : (
      //         (step4Data.takehomecommissionamount / 100) *
      //         (100 - step3Data.agentCommission)
      //       ).toFixed(2);

      /////////////cold wall bank commission/////
      newdata.bankcommission = step4Data.bankcommission;

      /////////////in house agent commission/////

      // newdata.agentCommissionamount = (
      //   employees.find((emp) => emp.id == step3Data.agentid)?.role == "Employee"
      //     ? (step4Data.takehomecommissionamount / 100) *
      //       step3Data.agentCommission
      //     : ((step4Data.takehomecommissionamount - step4Data.bankcommission) /
      //         100) *
      //       step3Data.agentCommission
      // ).toFixed(2);
      newdata.agentCommissionamount = !step3Data.fixedagentcommission
        ? (
            (step4Data.takehomecommissionamount / 100) *
            asNumber(step3Data.agentCommission)
          ).toFixed(2)
        : asNumber(step3Data.agentCommission);

      newdata.thirdpartyagentcommissionamount = (
        (step4Data.totalCommissionamount / 100) *
        asNumber(step3Data.thirdpartyagentCommission)
      ).toFixed(2);

      newdata.agentCommissionamount = (
        newdata.agentCommissionamount - newdata.agentdiscount
      ).toFixed(2);
      newdata.teamleadCommissionamount = (
        newdata.teamleadCommissionamount - newdata.teamleaddiscount
      ).toFixed(2);

      newdata.totalCommissionamount = (
        newdata.totalCommissionamount -
        newdata.teamleaddiscount -
        newdata.agentdiscount
      ).toFixed(2);

      newdata.takehomecommissionamount = (
        newdata.takehomecommissionamount -
        newdata.teamleaddiscount -
        newdata.agentdiscount
      ).toFixed(2);

      setstep4Data(newdata);
      setFormData((prev) => ({ ...prev, step4: newdata }));
    } else {
      console.log("this is all the data " + JSON.stringify(formData));
    }

    if (currentStep < 5) setCurrentStep((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  // function formatDate(date) {
  //   // if (!date) return "";
  //   // const d = new Date(date);
  //   // const mm = String(d.getMonth() + 1).padStart(2, "0");
  //   // const dd = String(d.getDate()).padStart(2, "0");
  //   // const yyyy = d.getFullYear();
  //   // return `${mm}/${dd}/${yyyy}`;

  //   if (!date) return "";

  //   const d = new Date(date);

  //   const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  //   const dd = String(d.getUTCDate()).padStart(2, "0");
  //   const yyyy = d.getUTCFullYear();

  //   return `${mm}/${dd}/${yyyy}`;
  // }

  function formatDate(date) {
    if (!date || date == "") return "";

    const [yyyy, mm, dd] = date?.split("-");
    return `${mm}/${dd}/${yyyy}`;
  }

  function heading(title, required) {
    return (
      <div className="flex flex-row mb-1">
        <label className="block font-medium text-sm ">{title}</label>
        {required && (
          <label className="block font-medium text-sm text-red-700 ml-[2px] ">
            *
          </label>
        )}
      </div>
    );
  }

  function stats(title, description) {
    return (
      <div className="lg:w-[32%] flex  flex-col items-center mb-4">
        <p className="text-black/50 text-center font-medium">{title}</p>
        <p className=" text-sm font-semibold text-black">
          {description || "-"}
        </p>
      </div>
    );
  }
  function stats3(title, description) {
    return (
      <div className="w-full flex  flex-row items-center justify-between mb-4">
        <p className="text-white/90 text-center">{title}</p>
        <p className=" text-sm font-semibold text-white">
          {formatCurrency(description || "-")}
        </p>
      </div>
    );
  }

  function stats2(title, description) {
    return (
      <div className="w-[49%] flex  flex-col items-center mb-2">
        <p className="text-gray-600">{title}</p>
        <p className=" text-sm font-semibold text-black">
          {description || "-"}
        </p>
      </div>
    );
  }

  function formatPhone(value) {
    const digits = value.replace(/\D/g, "").slice(0, 10);

    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;

    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  if (loadError) return <div>Map failed to load</div>;
  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[55%] h-[90%]  bg-white">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-black/10 h-[12%] bg-[#1E293B] text-white ">
            <div>
              <h2 className="text-xl font-semibold">Add New Deal</h2>
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          <div className="w-full  h-[78%]  overflow-y-auto form-scrollbar py-2">
            {/* Stepper */}
            <div className="p-3 lg:p-6 ">
              <Stepper
                steps={steps}
                currentStep={currentStep}
                onStepClick={handleStepClick}
              />
            </div>

            {/* Content Area */}
            <div className="p-3 lg:p-6">
              <div
                className={`mb-6 flex   ${
                  steps[currentStep - 1].title == "Client Information"
                    ? "flex-row justify-between"
                    : "flex-col"
                }`}
              >
                <h3 className="text-xl sm:text-2xl font-semibold text-foreground ">
                  {steps[currentStep - 1].title}
                </h3>
                <div className="flex flex-row items-center">
                  <p className="font-semibold text-foreground text-sm ">
                    {steps[currentStep - 1].description}
                  </p>
                  {steps[currentStep - 1].description == "Sale Price" ? (
                    <p className="text-green-600  font-semibold  text-lg  ml-[5px]">
                      {formatCurrency(step1Data.offerPrice)}
                    </p>
                  ) : steps[currentStep - 1].title == "Client Information" ? (
                    <div
                      onClick={() => setPickerOpen(true)}
                      className="p-1 rounded-full flex justify-center items-center bg-gradient-to-r from-[#0f172a] to-[#1E293B] hover:cursor-pointer"
                    >
                      <FaPlus className="text-white" size={18} />
                    </div>
                  ) : null}
                </div>
              </div>

              {/* Step Content */}
              <div className="space-y-4 mb-8">
                {currentStep === 1 && (
                  <div className="w-full">
                    {/* Show the PDF import + Attach Purchase Agreement
                        controls for new deals AND when editing a Listing
                        Request (requestType === "fileRequest"). A file
                        request is just a shell — dragging it to Under
                        Contract on the deals board is effectively a
                        turn-in, so the team needs to attach the PA and
                        can use the PDF import to pre-fill fields. */}
                    {(!editdata || editdata?.requestType === "fileRequest") && (
                      <div className="mb-4">
                        <ImportFromPDFButton
                          onApply={handleParsedFields}
                          isLoading={isLoading}
                          savedImport={pdfImportState}
                          onSavedImportChange={setPdfImportState}
                          onFilesPicked={(file) => {
                            // Auto-attach only if the agent hasn't already
                            // picked a different PDF in the attach control.
                            if (!attachedPaFile) {
                              setAttachedPaFile(file);
                              setPaFileAutoAttached(true);
                            }
                          }}
                        />
                      </div>
                    )}
                    {(!editdata || editdata?.requestType === "fileRequest") && (
                      <div className="mb-4">
                        <AttachPurchaseAgreement
                          file={attachedPaFile}
                          onChange={(f) => {
                            setAttachedPaFile(f);
                            // Once the user touches the picker manually,
                            // it's no longer "auto-attached".
                            setPaFileAutoAttached(false);
                          }}
                          autoAttached={paFileAutoAttached}
                          disabled={isLoading}
                        />
                      </div>
                    )}
                    <div className="flex flex-col lg:flex-row lg:justify-between w-full mt-3">
                      {/* <div className="lg:w-[49%] mt-3 lg:mt-0">
                        {heading("Listing Price", true)}
                        <input
                          type="number"
                          value={step1Data.listingPrice}
                          placeholder="Enter Listing Price"
                          onChange={(e) =>
                            setStep1Data({
                              ...step1Data,
                              listingPrice: e.target.value,
                            })
                          }
                          className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                        ></input>
                      </div> */}

                      <div className="lg:w-[49%]">
                        {heading("Sales Price", true)}
                        <input
                          type="text"
                          value={formatNumber(step1Data.offerPrice)}
                          placeholder="Enter Sales Price"
                          onChange={(e) => {
                            const rawValue = removeCommas(
                              e.target.value,
                            ).replace(/[^0-9]/g, "");

                            setStep1Data({
                              ...step1Data,
                              offerPrice: rawValue, // ✅ backend ko ye hi jayega
                            });
                          }}
                          className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                        ></input>
                      </div>
                      <div className="lg:w-[49%] mt-3 lg:mt-0">
                        {heading("Earnest Money", true)}
                        <input
                          type="text"
                          value={formatNumber(step1Data.earnestMoney)}
                          placeholder="Enter Earnest Money"
                          onChange={(e) => {
                            const rawValue = removeCommas(
                              e.target.value,
                            ).replace(/[^0-9]/g, "");

                            setStep1Data({
                              ...step1Data,
                              earnestMoney: rawValue,
                            });
                          }}
                          className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                        ></input>
                      </div>
                    </div>
                    <div className="flex flex-col lg:flex-row lg:justify-between w-full mt-3">
                      <div className="lg:w-[49%] flex position relative flex-col">
                        {heading("Deal Stage", true)}
                        <div
                          onClick={() => {
                            if (!isStatus) setdealstagepopup(!dealstagepopup);
                          }}
                          className={`w-full border border-slate-300 ${
                            step1Data.dealStage == ""
                              ? "text-gray-400"
                              : "text-textcolor"
                          } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                          // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                        >
                          {isStatus
                            ? isStatus
                            : step1Data.dealStage
                              ? step1Data.dealStage
                              : "Select Deal Stage"}
                        </div>

                        <DealStagePopup
                          style={{ top: "70px" }}
                          visible={dealstagepopup}
                          activateoutsidecontainerclick={() => {
                            setdealstagepopup(false);
                          }}
                          onClickcorrect={(item) => {
                            // Stage only — picking "Closed" never fills in a
                            // closing date the agent didn't enter.
                            setStep1Data({
                              ...step1Data,
                              dealStage: item,
                            });
                            setdealstagepopup(false);
                          }}
                        />
                      </div>
                      <div className="lg:w-[49%] mt-3 lg:mt-0">
                        {heading("Closing Date", true)}
                        <div className="relative">
                          <input
                            type="text"
                            placeholder="MM/DD/YYYY"
                            value={formatDate(step1Data.closingdate)}
                            readOnly
                            onClick={openDatePicker}
                            className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                          ></input>
                          <div
                            className="absolute top-3 right-3"
                            onClick={openDatePicker}
                          >
                            <Calendar size={18} />
                          </div>
                          <input
                            type="date"
                            id="closingDate"
                            ref={hiddenDateRef}
                            value={step1Data.closingdate || ""}
                            onChange={(e) => {
                              setStep1Data({
                                ...step1Data,
                                closingdate: e.target.value,
                              });
                            }}
                            className="absolute left-0 top-0 w-0 h-0 opacity-0 pointer-events-none"
                          ></input>
                        </div>
                      </div>
                      {/* <div className="w-full lg:w-[49%] flex position relative flex-col">
                        {heading("Priority", true)}
                        <div
                          onClick={() => setprioritypopup(!prioritypopup)}
                          className={`w-full border border-slate-300 ${
                            step1Data.Priority == ""
                              ? "text-gray-400"
                              : "text-textcolor"
                          } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                          // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                        >
                          {step1Data.Priority == ""
                            ? "Select Priority"
                            : step1Data.Priority}
                        </div>

                        <PriorityPopup
                          style={{ top: "70px" }}
                          visible={prioritypopup}
                          activateoutsidecontainerclick={() => {
                            setprioritypopup(false);
                          }}
                          onClickcorrect={(item) => {
                            setStep1Data({
                              ...step1Data,
                              Priority: item,
                            });
                            setprioritypopup(false);
                          }}
                        />
                      </div> */}
                    </div>

                    <div className="flex flex-col lg:flex-row lg:justify-between w-full mt-3">
                      <div className="lg:w-[49%] flex position relative flex-col">
                        {heading("Financing Type", true)}
                        <div
                          onClick={() =>
                            setfinancingTypepopup(!financingTypepopup)
                          }
                          className={`w-full border border-slate-300 ${
                            step1Data.financingType === ""
                              ? "text-gray-400"
                              : "text-textcolor"
                          } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                          // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                        >
                          {step1Data.financingType === ""
                            ? "Select Financing Type"
                            : step1Data.financingType}
                        </div>

                        <FinancingTypPopup
                          style={{ top: "70px" }}
                          visible={financingTypepopup}
                          activateoutsidecontainerclick={() => {
                            setfinancingTypepopup(false);
                          }}
                          onClickcorrect={(item) => {
                            setStep1Data({
                              ...step1Data,
                              financingType: item,
                            });
                            setfinancingTypepopup(false);
                          }}
                        />
                      </div>
                      <div className="lg:w-[49%] mt-3 lg:mt-0">
                        {heading("Financing Deadline", true)}
                        <div className="relative">
                          <input
                            type="text"
                            placeholder="MM/DD/YYYY"
                            value={formatDate(step1Data.financingDeadline)}
                            readOnly
                            onClick={openDatePicker2}
                            className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                          ></input>
                          <div
                            className="absolute top-3 right-3"
                            onClick={openDatePicker2}
                          >
                            <Calendar size={18} />
                          </div>
                          <input
                            type="date"
                            id="financeDate"
                            ref={hiddenDateRef2}
                            value={step1Data.financingDeadline || ""}
                            onChange={(e) =>
                              setStep1Data({
                                ...step1Data,
                                financingDeadline: e.target.value,
                              })
                            }
                            className="absolute left-0 top-0 w-0 h-0 opacity-0 pointer-events-none"
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col lg:flex-row lg:justify-between w-full flex-wrap">
                      <div className="lg:w-[49%] flex position relative flex-col mt-3 ">
                        {heading("Inspection", true)}
                        <div
                          onClick={() => setinspection(!inspectionPopup)}
                          className={`w-full border border-slate-300 ${
                            step1Data.inspection == ""
                              ? "text-gray-400"
                              : "text-textcolor"
                          } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                          // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                        >
                          {step1Data.inspection == ""
                            ? "Select Inspection"
                            : step1Data.inspection}
                        </div>

                        <InspectionPopup
                          style={{ top: "70px" }}
                          visible={inspectionPopup}
                          activateoutsidecontainerclick={() => {
                            setinspection(false);
                          }}
                          onClickcorrect={(item) => {
                            setStep1Data({
                              ...step1Data,
                              inspection: item,
                            });
                            setinspection(false);
                          }}
                        />
                      </div>
                      {step1Data.inspection === "Yes" && (
                        <div className="lg:w-[49%] mt-3 ">
                          {heading("Inspection Deadline", true)}
                          <div className="relative">
                            <input
                              type="text"
                              placeholder="MM/DD/YYYY"
                              value={formatDate(step1Data.inspectionDeadline)}
                              readOnly
                              onClick={openDatePicker3}
                              className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                            ></input>
                            <div
                              className="absolute top-3 right-3"
                              onClick={openDatePicker3}
                            >
                              <Calendar size={18} />
                            </div>
                            <input
                              type="date"
                              id="inspectionDeadline"
                              ref={hiddenDateRef3}
                              value={step1Data.inspectionDeadline || ""}
                              onChange={(e) =>
                                setStep1Data({
                                  ...step1Data,
                                  inspectionDeadline: e.target.value,
                                })
                              }
                              className="absolute left-0 top-0 w-0 h-0 opacity-0 pointer-events-none"
                            ></input>
                          </div>
                        </div>
                      )}
                      {/* </div>
                    <div className="flex flex-col lg:flex-row lg:justify-between w-full mt-3"> */}
                      {/* <div className="w-full lg:w-[49%]">
                        {heading("MLS Number", true)}

                        <input
                          type="text"
                          value={step1Data.mlsNumber}
                          onChange={(e) =>
                            setStep1Data({
                              ...step1Data,
                              mlsNumber: e.target.value,
                            })
                          }
                          placeholder="MLS123456"
                          className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                        />
                      </div> */}

                      <div className="lg:w-[49%] flex position relative flex-col mt-3 ">
                        {heading("Property Type", false)}
                        <div
                          onClick={() =>
                            setpropertytypepopup(!propertytypepopup)
                          }
                          className={`w-full border border-slate-300 ${
                            step1Data.propertyType == ""
                              ? "text-gray-400"
                              : "text-textcolor"
                          } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                          // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                        >
                          {step1Data.propertyType == ""
                            ? "Select Property Type"
                            : step1Data.propertyType}
                        </div>

                        <PropertyTypePopup
                          style={{ top: "70px" }}
                          visible={propertytypepopup}
                          activateoutsidecontainerclick={() => {
                            setpropertytypepopup(false);
                          }}
                          onClickcorrect={(item) => {
                            setStep1Data({
                              ...step1Data,
                              propertyType: item,
                            });
                            setpropertytypepopup(false);
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col lg:flex-row lg:justify-between w-full mt-3">
                      {/* <LoadScript
                        googleMapsApiKey="AIzaSyClMaFJLo3buNYK-siytTa6AWD_72TgrE8" // apni key yahan lagao
                        libraries={libraries}
                      > */}
                      <div className="flex flex-col lg:flex-row lg:justify-between w-full mt-3">
                        <div className="w-full relative">
                          {heading("Property Address", true)}
                          {isPrefilled("propertyaddress") && (
                            <div className="text-xs text-gray-500 -mt-1 mb-1">{seedSourceLabel}</div>
                          )}

                          <Autocomplete
                            onLoad={(ref) => (autoCompleteRef.current = ref)}
                            onPlaceChanged={handlePlaceChanged}
                          >
                            <input
                              type="text"
                              placeholder="123 Main Street"
                              value={step1Data.propertyaddress || ""}
                              onChange={(e) => {
                                markEdited("propertyaddress");
                                setStep1Data({
                                  ...step1Data,
                                  propertyaddress: e.target.value,
                                });
                              }}
                              className={`w-full border border-slate-300 rounded-lg p-2 pr-10 focus:border-[#1E293B] outline-none ${
                                isPrefilled("propertyaddress")
                                  ? "border-l-4 border-l-amber-400"
                                  : ""
                              }`}
                            />
                          </Autocomplete>

                          {/* Current location button */}
                          {/* <button
                              type="button"
                              onClick={handleCurrentLocation}
                              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-[#1E293B]"
                              title="Use current location"
                            >
                              <MapPin size={20} />
                            </button> */}
                        </div>
                      </div>
                      {/* </LoadScript> */}
                      {/* <div className="w-full">
                        {heading("Property Address", true)}
                        <input
                          type="text"
                          placeholder="123 Main Street"
                          value={step1Data.propertyaddress || ""}
                          onChange={(e) =>
                            setStep1Data({
                              ...step1Data,
                              propertyaddress: e.target.value,
                            })
                          }
                          className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                        />
                      </div> */}
                    </div>
                    <div className="w-full mt-5">
                      {heading("Property Photos")}

                      {step1Data.propertyphoto?.length > 0 ? (
                        <div
                          className={`border-2 border-dashed rounded-lg  text-center transition-all cursor-pointer border-gray-300 w-full h-[250px] overflow-hidden`}
                          onClick={() =>
                            document.getElementById("propertyImages").click()
                          }
                        >
                          <img
                            src={step1Data.propertyphoto[0]}
                            alt={`preview-${0}`}
                            className="w-full h-full object-cover"
                          />
                        </div>
                      ) : (
                        <div
                          className={`border-2 border-dashed rounded-lg p-8 text-center transition-all cursor-pointer ${
                            dragActive
                              ? "border-blue-500 bg-blue-50"
                              : "border-gray-300 hover:border-blue-400"
                          }`}
                          onClick={() =>
                            document.getElementById("propertyImages").click()
                          }
                          onDrop={handleDrop}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                        >
                          <svg
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            width="48"
                            height="48"
                            className="mx-auto opacity-30"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                              clipRule="evenodd"
                            />
                          </svg>

                          <p className="mt-4 text-gray-500">
                            Click to upload or drag & drop property photos
                          </p>
                          <p className="text-xs text-gray-400 mt-2">
                            JPG, PNG, GIF up to 10MB
                          </p>
                        </div>
                      )}
                      <input
                        type="file"
                        id="propertyImages"
                        multiple
                        accept="image/*"
                        className="hidden"
                        onChange={handleImageSelect}
                      />
                    </div>

                    <div className="w-full mt-6">
                      <p className="font-semibold text-[15px] text-[#1E293B]">
                        Title Information
                      </p>
                      <p className="text-xs text-gray-400 mb-3">
                        Each side can use a different title company. Pick from
                        your preferred vendors, add a new one, or use a one-time
                        entry.
                      </p>
                      <div className="mb-4">
                        <TitleVendorPicker
                          label={
                            step2Data.clientType === "Buyer"
                              ? "Buyer's Title"
                              : step2Data.clientType === "Seller"
                                ? "Seller's Title"
                                : "Your Title"
                          }
                          tag="Your side"
                          vendors={titleVendors}
                          value={{
                            company: step1Data.titleCompany,
                            officerName: step1Data.titleCloserName,
                            email: step1Data.titleCloserEmail,
                            phone: step1Data.titleCloserPhone,
                          }}
                          onChange={(val) =>
                            setStep1Data((d) => ({
                              ...d,
                              titleCompany: val.company,
                              titleCloserName: val.officerName,
                              titleCloserEmail: val.email,
                              titleCloserPhone: val.phone,
                            }))
                          }
                          onVendorAdded={handleAddTitleVendor}
                        />
                      </div>
                      <div>
                        <TitleVendorPicker
                          label={
                            step2Data.clientType === "Buyer"
                              ? "Seller's Title"
                              : step2Data.clientType === "Seller"
                                ? "Buyer's Title"
                                : "Other Side's Title"
                          }
                          vendors={titleVendors}
                          value={{
                            company: step1Data.otherTitleCompany,
                            officerName: step1Data.otherTitleCloserName,
                            email: step1Data.otherTitleCloserEmail,
                            phone: step1Data.otherTitleCloserPhone,
                          }}
                          onChange={(val) =>
                            setStep1Data((d) => ({
                              ...d,
                              otherTitleCompany: val.company,
                              otherTitleCloserName: val.officerName,
                              otherTitleCloserEmail: val.email,
                              otherTitleCloserPhone: val.phone,
                            }))
                          }
                          onVendorAdded={handleAddTitleVendor}
                        />
                      </div>
                    </div>

                    <div className="w-full mt-6">
                      {heading("Notes")}
                      <p className="text-xs text-gray-400 mb-2 -mt-1">
                        Visible to everyone on the file.
                      </p>
                      <textarea
                        rows={3}
                        placeholder="e.g. Buyer needs a rush close before month-end. Title ordered 5/12."
                        value={step1Data.notes || ""}
                        onChange={(e) =>
                          setStep1Data({ ...step1Data, notes: e.target.value })
                        }
                        className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none resize-y"
                      />
                    </div>
                  </div>
                )}
                {currentStep === 2 && (
                  <div className="w-full">
                    <div className="flex flex-col lg:flex-row lg:justify-between w-full my-3">
                      <div className="w-full flex position relative flex-col">
                        {heading("Client Type", true)}
                        <div
                          onClick={() => setbuyertypepopup(!buyertypepopup)}
                          className={`w-full border border-slate-300 ${
                            step2Data.clientType == ""
                              ? "text-gray-400"
                              : "text-textcolor"
                          } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                          // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                        >
                          {step2Data.clientType == ""
                            ? "Select Client Type"
                            : step2Data.clientType}
                        </div>

                        <ClientTypePopup
                          style={{ top: "70px" }}
                          visible={buyertypepopup}
                          activateoutsidecontainerclick={() => {
                            setbuyertypepopup(false);
                          }}
                          onClickcorrect={(item) => {
                            let data = { ...step2Data };
                            data.clientType = item;

                            setStep2Data(data);
                            setbuyertypepopup(false);

                            setstep4Data({
                              ...step4Data,
                              totalcommissionrate: item == "Buyer" ? 2.7 : 3.5,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="mt-2 space-y-2">
                      {step2Data.clientinfo.filter((id) => id).length === 0 && (
                        // Big, obvious empty-state CTA so users don't have
                        // to hunt for the small "+" button in the modal
                        // header. Click anywhere in the box to open the
                        // contact picker.
                        <button
                          type="button"
                          onClick={() => setPickerOpen(true)}
                          className="w-full mt-1 px-4 py-6 border-2 border-dashed border-slate-300 hover:border-[#1E293B] hover:bg-slate-50 rounded-xl flex flex-col items-center justify-center gap-2 transition cursor-pointer"
                        >
                          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-[#0f172a] to-[#1E293B] flex items-center justify-center">
                            <FaPlus className="text-white" size={18} />
                          </div>
                          <div className="text-sm font-semibold text-slate-900">
                            Add a Client
                          </div>
                          <div className="text-xs text-slate-500">
                            Pick from your contacts or create a new one
                          </div>
                        </button>
                      )}
                      {step2Data.clientinfo.map((item, index) => {
                        if (!item) return null;
                        const contact = getContactById(item);
                        return (
                          <div
                            key={`${item}-${index}`}
                            className="relative group p-4 rounded-lg bg-gray-50 border border-transparent"
                          >
                            <div className="absolute top-3 right-3 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition">
                              <button
                                type="button"
                                onClick={() => handleEditClient(contact)}
                                className="inline-flex items-center gap-1 text-xs font-medium text-slate-600 bg-white border border-slate-200 hover:border-slate-400 hover:text-slate-900 rounded-md px-2 py-1 shadow-sm"
                              >
                                <Pencil size={12} /> Edit
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  const data = { ...step2Data };
                                  data.clientinfo = data.clientinfo.filter(
                                    (_, i) => i !== index,
                                  );
                                  setStep2Data(data);
                                }}
                                className="inline-flex items-center gap-1 text-xs font-medium text-red-600 bg-white border border-red-200 hover:border-red-400 hover:bg-red-50 rounded-md px-2 py-1 shadow-sm"
                                aria-label="Remove client"
                              >
                                <Trash2 size={12} />
                              </button>
                            </div>
                            <div className="text-[11px] uppercase tracking-wider font-semibold text-slate-400 mb-1">
                              Client {index + 1}
                            </div>
                            <div className="text-sm font-semibold text-slate-900">
                              {contact.name || "(no name)"}
                            </div>
                            <div className="text-[13px] text-slate-600 mt-0.5 flex flex-wrap gap-3">
                              {contact.email && <span>{contact.email}</span>}
                              {contact.phone && (
                                <span>{formatPhone(contact.phone)}</span>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {currentStep === 3 && (
                  <div className="w-full">
                    <div className="flex flex-col lg:flex-row justify-between">
                      <div className="w-full flex position relative flex-col">
                        {heading("Team Lead", true)}
                        <div
                          onClick={() => setteamleadpopup(!teamleadpopup)}
                          className={`w-full border border-slate-300 ${
                            step3Data.teamleadName == ""
                              ? "text-gray-400"
                              : "text-textcolor"
                          } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                          // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                        >
                          {step3Data.teamleadName == ""
                            ? "Select Team Lead"
                            : step3Data.teamleadName}
                        </div>

                        <UserPopUp
                          style={{ top: "70px" }}
                          visible={teamleadpopup}
                          activateoutsidecontainerclick={() => {
                            setteamleadpopup(false);
                          }}
                          data={teamleads.filter(isBookableTeamLead)}
                          onClickcorrect={(item) => {
                            setStep3Data({
                              ...step3Data,
                              teamleadName:
                                item.firstname + " " + item.lastname,
                              assignedteamlead: item.id,
                            });
                            setteamleadpopup(false);
                          }}
                        />
                      </div>
                    </div>

                    {(user.role == "Admin" ||
                      user.role == "Supervisor" ||
                      user.role === "Accountant") && (
                      <>
                        <div className="mt-4">
                          <div className="w-full flex position relative flex-col">
                            <div className="flex flex-row justify-between w-full items-center ">
                              {heading("Split Type", true)}
                              {step3Data.splittype === "TeamSplit" && (
                                <div className="flex flex-row justify-center  items-center mb-[10px]">
                                  <label className="block font-medium text-sm ">
                                    {"In-House Agent Referral"}
                                  </label>
                                  <button
                                    onClick={() => {
                                      let newdata = { ...step3Data };
                                      newdata["inhousereferral"] =
                                        !step3Data.inhousereferral;
                                      setStep3Data(newdata);
                                    }} // ✅ important
                                    className={`ml-[10px] relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-300  ${
                                      step3Data.inhousereferral
                                        ? "bg-themeColor"
                                        : "bg-gray-300"
                                    }`}
                                  >
                                    <span
                                      className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                                        step3Data.inhousereferral
                                          ? "translate-x-6"
                                          : "translate-x-1"
                                      }`}
                                    />
                                  </button>
                                </div>
                              )}
                            </div>
                            <div
                              onClick={() => setsplitpopup(!splitpopup)}
                              className={`w-full border border-slate-300 ${
                                step3Data.splitdescription == ""
                                  ? "text-gray-400"
                                  : "text-textcolor"
                              } rounded-lg p-2 focus:border-[#1E293B] outline-none bg-white`}
                              // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                            >
                              {step3Data.splitdescription == ""
                                ? "Select Split Type"
                                : step3Data.splitdescription}
                            </div>

                            <SplitTypePopup
                              style={{ top: "70px" }}
                              visible={splitpopup}
                              activateoutsidecontainerclick={() => {
                                setsplitpopup(false);
                              }}
                              data={teamleads}
                              onClickcorrect={(item) => {
                                let newdata = { ...step3Data };
                                if (item.value == "TeamSplit") {
                                  newdata.thirdpartyagentCommission = 0;
                                  newdata.thirdpartyagentName = "";
                                } else if (item.value == "Referral") {
                                  newdata.agentCommission = 0;
                                  newdata.agentName = "";
                                  newdata.agentid = "";
                                  newdata.id = "";
                                } else {
                                  newdata.agentCommission = 0;
                                  newdata.agentName = "";
                                  newdata.agentid = "";
                                  newdata.thirdpartyagentCommission = 0;
                                  newdata.thirdpartyagentName = "";
                                }

                                newdata.splittype = item.value;
                                newdata.splitdescription = item.description;
                                setStep3Data(newdata);
                                setsplitpopup(false);
                              }}
                            />
                          </div>
                          {(step3Data.splittype === "TeamSplit" ||
                            step3Data.splittype === "Referral") && (
                            <div className="flex justify-between mt-3">
                              <div className="lg:w-[49%] flex position relative flex-col">
                                {heading("Agent Name", true)}
                                {isPrefilled("agentName") && (
                                  <div className="text-xs text-gray-500 -mt-1 mb-1">{seedSourceLabel}</div>
                                )}
                                <div
                                  onClick={() => {
                                    markEdited("agentName");
                                    setagentpopup(!agentpopup);
                                  }}
                                  className={`w-full border border-slate-300 ${
                                    step3Data.agentName == ""
                                      ? "text-gray-400"
                                      : "text-textcolor"
                                  } rounded-lg p-2 focus:border-[#1E293B] outline-none bg-white ${
                                    isPrefilled("agentName")
                                      ? "border-l-4 border-l-amber-400"
                                      : ""
                                  }`}
                                >
                                  {step3Data.agentName == ""
                                    ? "Select Agent"
                                    : step3Data.agentName}
                                </div>

                                <UserPopUp
                                  style={{ top: "70px" }}
                                  visible={agentpopup}
                                  activateoutsidecontainerclick={() => {
                                    setagentpopup(false);
                                  }}
                                  data={employees.filter(
                                    (emp) =>
                                      emp.type !== 1 &&
                                      emp.type !== 2 &&
                                      !emp.isDemo,
                                  )}
                                  onClickcorrect={(item) => {
                                    setStep3Data({
                                      ...step3Data,
                                      agentName:
                                        item.firstname + " " + item.lastname,
                                      agentid: item.id,
                                    });
                                    setagentpopup(false);
                                  }}
                                />
                              </div>

                              {/* Agent Commission */}
                              <div className="lg:w-[49%]">
                                <div className="flex flex-row justify-between w-full items-center ">
                                  {heading(
                                    `Agent Commission ${step3Data.fixedagentcommission ? "($)" : "(%)"}`,
                                    true,
                                  )}

                                  <div className="flex flex-row justify-center  items-center mb-1">
                                    <label className="block font-medium text-sm ">
                                      {"Fixed"}
                                    </label>
                                    <button
                                      onClick={() => {
                                        let newdata = { ...step3Data };
                                        newdata["fixedagentcommission"] =
                                          !step3Data.fixedagentcommission;
                                        newdata["agentCommission"] = 0;

                                        setStep3Data(newdata);
                                      }} // ✅ important
                                      className={`ml-[10px] relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-300  ${
                                        step3Data.fixedagentcommission
                                          ? "bg-themeColor"
                                          : "bg-gray-300"
                                      }`}
                                    >
                                      <span
                                        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                                          step3Data.fixedagentcommission
                                            ? "translate-x-6"
                                            : "translate-x-1"
                                        }`}
                                      />
                                    </button>
                                  </div>
                                </div>
                                <input
                                  type="number"
                                  placeholder="Enter Agent Commission"
                                  value={step3Data.agentCommission || ""}
                                  onChange={(e) =>
                                    setStep3Data({
                                      ...step3Data,
                                      agentCommission: e.target.value,
                                    })
                                  }
                                  className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                                />
                              </div>
                            </div>
                          )}

                          {step3Data.splittype === "Referral" && (
                            <div className="flex justify-between mt-3">
                              <div className="lg:w-[49%] flex position relative flex-col">
                                {heading("Referal Agent Name", true)}
                                <input
                                  type="text"
                                  placeholder="Enter referal agent name"
                                  value={step3Data.thirdpartyagentName || ""}
                                  onChange={(e) =>
                                    setStep3Data({
                                      ...step3Data,
                                      thirdpartyagentName: e.target.value,
                                    })
                                  }
                                  className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                                />
                              </div>

                              {/*Referal  Agent Commission */}
                              <div className="lg:w-[49%]">
                                {heading("Referal Agent Percentage (%)", true)}
                                <input
                                  type="number"
                                  placeholder="Enter agent commission"
                                  value={
                                    step3Data.thirdpartyagentCommission || ""
                                  }
                                  onChange={(e) =>
                                    setStep3Data({
                                      ...step3Data,
                                      thirdpartyagentCommission: e.target.value,
                                    })
                                  }
                                  className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    <div className="flex flex-col lg:flex-row lg:justify-between mt-3">
                      <div
                        className={`${
                          user.role === "Admin" ||
                          user.role === "Supervisor" ||
                          user.role === "Accountant"
                            ? "lg:w-[49%]"
                            : "w-full"
                        } flex position relative flex-col`}
                      >
                        {heading("Lead Source", true)}
                        <div
                          onClick={() => setleadpopup(!leadpopup)}
                          className={`w-full border border-slate-300 ${
                            step3Data.leadsource == ""
                              ? "text-gray-400"
                              : "text-textcolor"
                          } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                          // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                        >
                          {step3Data.leadsource == ""
                            ? "Select Lead Source"
                            : step3Data?.leadsource?.abbreviation}
                        </div>

                        <LeadSourcePopup
                          style={{ top: "70px" }}
                          visible={leadpopup}
                          activateoutsidecontainerclick={() => {
                            setleadpopup(false);
                          }}
                          data={leadsource}
                          onClickcorrect={(item) => {
                            setStep3Data({
                              ...step3Data,
                              leadsource: item,
                              leadCommission:
                                item.leadCommission > 0
                                  ? item.leadCommission
                                  : 0,
                            });
                            setleadpopup(false);
                          }}
                        />
                      </div>
                      {(user.role == "Admin" ||
                        user.role == "Supervisor" ||
                        user.role === "Accountant") && (
                        <>
                          {/* Lead Commission */}
                          <div className="lg:w-[49%] mt-3 lg:mt-0">
                            {heading("Lead Commission (%)")}
                            <input
                              type="number"
                              placeholder="Enter Lead Commission"
                              value={step3Data.leadCommission || ""}
                              onChange={(e) =>
                                setStep3Data({
                                  ...step3Data,
                                  leadCommission: e.target.value,
                                })
                              }
                              className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                            />
                          </div>
                        </>
                      )}
                    </div>
                    {(user.role == "Admin" ||
                      user.role == "Supervisor" ||
                      user.role === "Accountant") && (
                      <div className="flex justify-between mt-4">
                        <div className="w-full lg:w-[49%] flex position relative flex-col">
                          {heading("Type", true)}
                          <div
                            onClick={() => setcappopup(!cappopup)}
                            className={`w-full border border-slate-300 ${
                              step3Data.captypedescription == ""
                                ? "text-gray-400"
                                : "text-textcolor"
                            } rounded-lg p-2 focus:border-[#1E293B] outline-none bg-white`}
                            // className="px-4 text-textcolor text-sm font-medium PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex"
                          >
                            {step3Data.captypedescription == ""
                              ? "Select Cap Type"
                              : step3Data.captypedescription}
                          </div>

                          <CapTypePopUp
                            style={{ top: "70px" }}
                            visible={cappopup}
                            paidtobank={paidtobank}
                            activateoutsidecontainerclick={() => {
                              setcappopup(false);
                            }}
                            onClickcorrect={(item) => {
                              setStep3Data({
                                ...step3Data,
                                captype: item.value,
                                captypedescription: item.description,
                              });
                              setcappopup(false);
                            }}
                          />
                        </div>
                        <div className="w-[49%]">
                          {heading("Broker Admin Fee")}
                          <input
                            type="text"
                            placeholder="Enter broker admin fee"
                            value={formatNumber(step3Data.brokeradminfee || "")}
                            onChange={(e) => {
                              const rawValue = removeCommas(
                                e.target.value,
                              ).replace(/[^0-9]/g, "");
                              setStep3Data({
                                ...step3Data,
                                brokeradminfee: rawValue,
                              });
                            }}
                            className="w-full border border-slate-300 rounded-md p-2 focus:border-[#1E293B] outline-none"
                          />
                          <small className="text-black/50">
                            Monthly admin fee if applicable
                          </small>
                        </div>
                      </div>
                    )}

                    {user.role == "Employee" && (
                      <div className="flex items-center gap-2 mt-4">
                        <input
                          type="checkbox"
                          id="confirm"
                          checked={confirm}
                          onChange={(e) => {
                            setconfirm(e.target.checked);
                          }}
                        />
                        <label htmlFor="confirm">
                          I confirm all details are accurate
                        </label>
                      </div>
                    )}
                  </div>
                )}
                {currentStep === 4 &&
                  (user.role == "Admin" ||
                    user.role == "Supervisor" ||
                    user.role === "Accountant") && (
                    <div className="space-y-4">
                      <div className="p-2 lg:p-3  items-center text border border-[#1E293B] rounded-lg bg-gray-200 flex flex-row flex-wrap">
                        <p className="text-[#1E293B] text-sm">
                          {(formData.step3.splittype == "Referral"
                            ? formData.step3.thirdpartyagentName +
                              (formData.step3.agentName
                                ? " & " + formData.step3.agentName + " - "
                                : " - ")
                            : formData.step3.splittype == "TeamSplit"
                              ? formData.step3.agentName + " - "
                              : "") +
                            (formData.step3.leadsource.abbreviation
                              ? formData.step3.leadsource.abbreviation
                              : "N/A") +
                            ": "}
                        </p>

                        {(formData.step3.splittype == "Referral" ||
                          formData.step3.splittype == "TeamSplit") && (
                          <p className="text-[#1E293B]   text-sm ml-[5px]">
                            {(formData.step3.splittype == "Referral"
                              ? formData.step3.thirdpartyagentCommission
                              : formData.step3.splittype == "TeamSplit"
                                ? step3Data.fixedagentcommission
                                  ? `$${formData.step3.agentCommission} `
                                  : formData.step3.agentCommission
                                : "") +
                              (!step3Data.fixedagentcommission ||
                              formData.step3.thirdpartyagentCommission
                                ? `% to `
                                : `to `) +
                              (formData.step3.splittype == "Referral"
                                ? formData.step3.thirdpartyagentName
                                : formData.step3.splittype == "TeamSplit"
                                  ? formData.step3.agentName
                                  : "") +
                              ", "}

                            {/* Scott - Zillow Lead: 42% to Scott, 40% to Zillow, 18% to
                        Henry */}
                          </p>
                        )}

                        {formData.step3.splittype == "Referral" && (
                          <p
                            className={`text-[#1E293B]   text-sm ${
                              formData.step3.agentCommission > 0
                                ? "ml-[5px]"
                                : ""
                            }`}
                          >
                            {formData.step3.splittype == "Referral" &&
                              (formData.step3.agentCommission > 0
                                ? step3Data.fixedagentcommission
                                  ? `$${formData.step3.agentCommission} `
                                  : formData.step3.agentCommission
                                : "") +
                                (formData.step3.agentCommission > 0
                                  ? !step3Data.fixedagentcommission
                                    ? `% to `
                                    : `to `
                                  : "") +
                                (formData.step3.splittype == "Referral"
                                  ? formData.step3.agentName
                                  : "") +
                                (formData.step3.agentCommission > 0
                                  ? ", "
                                  : "")}
                          </p>
                        )}

                        {step3Data.leadCommission > 0 && (
                          <p className="text-[#1E293B]   text-sm ml-[5px]">
                            {asNumber(step3Data.leadCommission) +
                              "% to " +
                              (formData.step3.leadsource.abbreviation
                                ? formData.step3.leadsource.abbreviation
                                : "N/A") +
                              ", "}
                          </p>
                        )}

                        <p className="text-[#1E293B]   text-sm ml-[5px]">
                          {100 -
                            (step3Data.fixedagentcommission
                              ? parseInt(
                                  (asNumber(step3Data.agentCommission) /
                                    step4Data.takehomecommissionamount) *
                                    100,
                                )
                              : asNumber(step3Data.agentCommission)) -
                            asNumber(step3Data.thirdpartyagentCommission) -
                            asNumber(step3Data.leadCommission) +
                            "% to " +
                            formData.step3.teamleadName}
                        </p>
                      </div>
                      <div className="flex flex-col lg:flex-row lg:justify-between mb-4">
                        <div className="lg:w-[49%] mt-3 lg:mt-0">
                          <div className="flex flex-row items-center justify-start mt-[5px] mb-[15px]">
                            <div
                              onClick={() => {
                                let data = { ...step4Data };
                                data.flatfee = true;
                                setstep4Data(data);
                              }}
                              className="flex flex-row items-center justify-center  hover:cursor-pointer"
                            >
                              <p className="PoppinsRegular text-black text-sm  ">
                                {heading("Fixed")}
                              </p>
                              {step4Data.flatfee ? (
                                <IoRadioButtonOn className=" ml-[5px] text-[#1E293B] border border-bordercolor rounded-full w-[20px] h-[20px] mb-1" />
                              ) : (
                                <IoRadioButtonOff className="ml-[5px]  text-grey border border-bordercolor rounded-full w-[20px] h-[20px] mb-1" />
                              )}
                            </div>
                            <div
                              onClick={() => {
                                let data = { ...step4Data };
                                data.flatfee = false;
                                setstep4Data(data);
                              }}
                              className="flex flex-row items-center justify-center ml-[15px] hover:cursor-pointer"
                            >
                              <p className="PoppinsRegular text-black text-sm  ">
                                {heading("Percentage")}
                              </p>
                              {!step4Data.flatfee ? (
                                <IoRadioButtonOn className=" ml-[5px] text-[#1E293B] border border-bordercolor rounded-full w-[20px] h-[20px] mb-1" />
                              ) : (
                                <IoRadioButtonOff className="ml-[5px] text-grey border border-bordercolor rounded-full w-[20px] h-[20px] mb-1" />
                              )}
                            </div>
                          </div>

                          {heading(
                            step4Data.flatfee
                              ? "Fixed Commission"
                              : "Total Commission Rate (%)",
                            true,
                          )}
                          {isPrefilled("totalcommissionrate") && !step4Data.flatfee && (
                            <div className="text-xs text-gray-500 -mt-1 mb-1">{seedSourceLabel}</div>
                          )}
                          <input
                            type="number"
                            value={
                              step4Data.flatfee
                                ? step4Data.flatfeeamount
                                : step4Data.totalcommissionrate
                            }
                            onChange={(e) => {
                              markEdited("totalcommissionrate");
                              if (step4Data.flatfee) {
                                setstep4Data({
                                  ...step4Data,
                                  flatfeeamount: e.target.value,
                                });
                              } else {
                                setstep4Data({
                                  ...step4Data,
                                  totalcommissionrate: e.target.value,
                                });
                              }
                            }}
                            placeholder="6.00"
                            className={`w-full border border-slate-300 rounded-md p-2 focus:border-[#1E293B] outline-none ${
                              isPrefilled("totalcommissionrate") && !step4Data.flatfee
                                ? "border-l-4 border-l-amber-400"
                                : ""
                            }`}
                          />
                          <small className="text-black/50">
                            Total commission percentage
                          </small>
                        </div>
                      </div>

                      {!step3Data.fixedagentcommission && (
                        <div className="flex flex-row justify-between w-full items-center">
                          <div className="w-[49%]">
                            {heading("Team Lead Discount")}
                            <input
                              type="number"
                              value={step4Data.teamleaddiscount}
                              onChange={(e) => {
                                const value = Number(e.target.value);
                                let teamleadcommission =
                                  (step4Data.takehomecommissionamount / 100) *
                                  (step3Data.captype == "pre"
                                    ? employees.find(
                                        (emp) => emp.id == step3Data.agentid,
                                      )?.role == "Employee"
                                      ? 100 - asNumber(step3Data.agentCommission) - 10
                                      : 100 - asNumber(step3Data.agentCommission)
                                    : 100 - asNumber(step3Data.agentCommission));

                                if (value <= teamleadcommission) {
                                  setstep4Data({
                                    ...step4Data,
                                    teamleaddiscount: e.target.value,
                                  });
                                }
                              }}
                              placeholder="6.00"
                              className="w-full border border-slate-300 rounded-md p-2 focus:border-[#1E293B] outline-none"
                            />
                          </div>

                          {step3Data.agentid != "" && (
                            <div className="w-[49%]">
                              {heading("Agent Discount")}
                              <input
                                type="number"
                                value={step4Data.agentdiscount}
                                onChange={(e) => {
                                  let agentcommission =
                                    (step4Data.takehomecommissionamount / 100) *
                                    asNumber(step3Data.agentCommission);
                                  const value = Number(e.target.value);

                                  if (value <= agentcommission) {
                                    setstep4Data({
                                      ...step4Data,
                                      agentdiscount: e.target.value,
                                    });
                                  }
                                }}
                                placeholder="6.00"
                                className="w-full border border-slate-300 rounded-md p-2 focus:border-[#1E293B] outline-none"
                              />
                            </div>
                          )}
                        </div>
                      )}
                      {/* <div className="flex flex-col lg:flex-row lg:justify-between mb-4">
                      {formData.step2.clientType == "Buyer" && (
                        <div className="lg:w-[49%]">
                          <label className="block text-sm font-medium mb-1">
                            Buyer Side Rate (%)*
                          </label>
                          <input
                            type="number"
                            placeholder="Enter buyer side rate"
                            className="w-full border border-slate-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                          />
                          <small className="text-black/50">
                            Enter the full sale price
                          </small>
                        </div>
                      )}

                      {formData.step2.clientType == "Seller" && (
                        <div className="lg:w-[49%] mt-3 lg:mt-0">
                          <label className="block text-sm font-medium mb-1">
                            Seller Side Rate (%)*
                          </label>
                          <input
                            type="number"
                            placeholder="Enter seller side rate"
                            className="w-full border border-slate-300 rounded-md p-2 focus:border-[#1E293B] outline-none"
                          />
                          <small className="text-black/50">
                            Total commission percentage
                          </small>
                        </div>
                      )}
                    </div> */}
                      <div className="bg-gray-100 rounded-lg px-6 py-8 mt-5">
                        <div className=" bg-gradient-to-r from-[#0f172a] to-[#1E293B] p-4 rounded-md mt-3">
                          <div className="flex justify-between  font-semibold">
                            <h2 className="text-white">Total Commission:</h2>
                            <p className="text-white">
                              {formatCurrency(
                                step4Data.totalCommissionamount -
                                  step4Data.agentdiscount -
                                  step4Data.teamleaddiscount,
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="border-b border-black/10 pb-3"></div>
                        {step3Data.leadCommission > 0 && (
                          <div className="bg-white p-4 rounded-md mt-3">
                            <div className="flex justify-between font-semibold">
                              <h2>
                                Lead Source Commission{" "}
                                {`(${step3Data.leadCommission}%)`} :
                              </h2>
                              <p>
                                {formatCurrency(
                                  (step4Data.totalCommissionamount / 100) *
                                    asNumber(step3Data.leadCommission),
                                )}
                              </p>
                            </div>
                          </div>
                        )}

                        {step3Data.thirdpartyagentCommission > 0 && (
                          <div className="bg-white p-4 rounded-md mt-3">
                            <div className="flex justify-between  font-semibold">
                              <h2>
                                Referal Agent Percentage{" "}
                                {`(${step3Data.thirdpartyagentCommission}%)`} :
                              </h2>
                              <p>
                                {formatCurrency(
                                  (step4Data.totalCommissionamount / 100) *
                                    asNumber(step3Data.thirdpartyagentCommission),
                                )}
                              </p>
                            </div>
                          </div>
                        )}
                        {employees.find((emp) => emp.id == step3Data.agentid)
                          ?.role != "Employee" &&
                          step3Data.captype == "pre" && (
                            <div className="flex justify-between mt-1 font-semibold">
                              <h2 className=" text-[#1E293B]">
                                Coldwell Banker Realty (10%):
                              </h2>
                              <p className=" text-[#1E293B]">
                                {formatCurrency(step4Data.bankcommission)}
                              </p>
                            </div>
                          )}

                        <div className="bg-white p-4 rounded-md mt-3">
                          <div className=" bg-gradient-to-r from-[#0f172a] to-[#1E293B] p-4 rounded-md mt-3">
                            <div className="flex justify-between  font-semibold">
                              <h2 className="text-white">
                                Total In-House Commission:
                              </h2>
                              <p className="text-white">
                                {formatCurrency(
                                  step4Data.takehomecommissionamount -
                                    step4Data.agentdiscount -
                                    step4Data.teamleaddiscount,
                                )}
                              </p>
                            </div>
                          </div>

                          {employees.find((emp) => emp.id == step3Data.agentid)
                            ?.role == "Employee" &&
                            step3Data.captype == "pre" && (
                              <div className="flex justify-between mt-1 font-semibold">
                                <h2 className=" text-[#1E293B]">
                                  Coldwell Banker Realty (10%):
                                </h2>
                                <p className=" text-[#1E293B]">
                                  {formatCurrency(step4Data.bankcommission)}
                                </p>
                              </div>
                            )}

                          <div className="flex justify-between  font-semibold mt-2  ">
                            <h2>
                              Team Lead Commission{" "}
                              {`${
                                step3Data.fixedagentcommission
                                  ? ""
                                  : "(" +
                                    (step3Data.captype == "pre"
                                      ? employees.find(
                                          (emp) => emp.id == step3Data.agentid,
                                        )?.role == "Employee"
                                        ? (
                                            100 -
                                            asNumber(step3Data.agentCommission) -
                                            10
                                          ).toFixed(2)
                                        : (
                                            100 - asNumber(step3Data.agentCommission)
                                          ).toFixed(2)
                                      : (
                                          100 - asNumber(step3Data.agentCommission)
                                        ).toFixed(2)) +
                                    "%)"
                              }`}
                              :
                            </h2>

                            <div className="flex flex-col items-end">
                              <p>
                                {formatCurrency(
                                  (step4Data.takehomecommissionamount / 100) *
                                    (step3Data.captype == "pre"
                                      ? employees.find(
                                          (emp) => emp.id == step3Data.agentid,
                                        )?.role == "Employee"
                                        ? 100 -
                                          (!step3Data.fixedagentcommission
                                            ? asNumber(step3Data.agentCommission)
                                            : 0) -
                                          10
                                        : 100 -
                                          (!step3Data.fixedagentcommission
                                            ? asNumber(step3Data.agentCommission)
                                            : 0)
                                      : 100 -
                                        (!step3Data.fixedagentcommission
                                          ? asNumber(step3Data.agentCommission)
                                          : 0)) -
                                    (step3Data.fixedagentcommission
                                      ? asNumber(step3Data.agentCommission)
                                      : 0),
                                )}
                              </p>
                              {step4Data.teamleaddiscount > 0 && (
                                <>
                                  <p className="text-red-600">
                                    {"- " +
                                      formatCurrency(
                                        step4Data.teamleaddiscount,
                                      )}
                                  </p>
                                  <p className="text-green-600">
                                    {formatCurrency(
                                      (step4Data.takehomecommissionamount /
                                        100) *
                                        (step3Data.captype == "pre"
                                          ? employees.find(
                                              (emp) =>
                                                emp.id == step3Data.agentid,
                                            )?.role == "Employee"
                                            ? 100 -
                                              asNumber(step3Data.agentCommission) -
                                              10
                                            : 100 - asNumber(step3Data.agentCommission)
                                          : 100 - asNumber(step3Data.agentCommission)) -
                                        step4Data.teamleaddiscount,
                                    )}
                                  </p>
                                </>
                              )}
                            </div>
                          </div>

                          {step3Data.agentCommission > 0 && (
                            <div className="flex justify-between  font-semibold ">
                              <h2>
                                Agent Commission{" "}
                                {`${step3Data.fixedagentcommission ? "(Fixed)" : "(" + asNumber(step3Data.agentCommission) + "%)"}`}
                              </h2>
                              <div className="flex flex-col items-end">
                                <p>
                                  {formatCurrency(
                                    step3Data.fixedagentcommission
                                      ? asNumber(step3Data.agentCommission)
                                      : (step4Data.takehomecommissionamount /
                                          100) *
                                          asNumber(step3Data.agentCommission),
                                  )}
                                </p>
                                {step4Data.agentdiscount > 0 && (
                                  <>
                                    <p className="text-red-600">
                                      {"- " +
                                        formatCurrency(step4Data.agentdiscount)}
                                    </p>
                                    <p className="text-green-600">
                                      {formatCurrency(
                                        (step4Data.takehomecommissionamount /
                                          100) *
                                          asNumber(step3Data.agentCommission) -
                                          step4Data.agentdiscount,
                                      )}
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                {currentStep === 6 &&
                  (user.role == "Admin" ||
                    user.role == "Supervisor" ||
                    user.role === "Accountant") && (
                    <div className="space-y-4">
                      <div className="bg-gray-100 rounded-xl px-5 py-5 mt-5">
                        <p className="font-medium">Broker Fee Tracking</p>
                        <div className="flex justify-between items-center border-b border-black/10 pb-4 mt-5">
                          <p>Admin Fee Date:</p>
                          <div>
                            <input
                              type="date"
                              id="closingDate"
                              className="w-full border border-slate-300 rounded-lg h-[30px] p-2 focus:border-[#1E293B] outline-none"
                            ></input>
                          </div>
                        </div>
                        <div className="flex justify-between items-center mt-4">
                          <p>Admin Fees This Month:</p>
                          <p>0</p>
                        </div>
                      </div>
                      <div className="bg-gray-100 rounded-xl px-5 py-5 mt-6">
                        <p className="font-medium">Commission Breakdown</p>
                        <div className="flex justify-between items-center mt-4">
                          <p>Cap Contribution:</p>
                          <p>0.00</p>
                        </div>
                      </div>
                    </div>
                  )}
                {currentStep === 5 &&
                  (user.role === "Admin" ||
                    user.role === "Supervisor" ||
                    user.role === "Accountant") && (
                    <div className="space-y-4">
                      <div className="bg-gray-100  rounded-xl px-5 py-5 mt-6">
                        <p className="font-medium text-black">
                          Deal Information
                        </p>

                        <div className="flex flew-row gap-x-[2%] mt-4 flex-wrap">
                          {/* {stats("MLS Number", formData.step1.mlsNumber)} */}
                          {stats("Property Type", formData.step1.propertyType)}

                          {stats(
                            "Sales Price",
                            formatCurrency(formData.step1.offerPrice),
                          )}
                          {stats(
                            "Earnest Money",
                            formatCurrency(formData.step1.earnestMoney),
                          )}
                          {/* {stats("Listing Price", formData.step1.listingPrice)} */}

                          {stats("Deal Stage", formData.step1.dealStage)}
                          {stats("Inspection", formData.step1.inspection)}
                          {/* {stats("Priority", formData.step1.Priority)} */}
                          {stats(
                            "Financing Type",
                            formData.step1.financingType,
                          )}
                        </div>
                      </div>

                      <div className="bg-gray-100  rounded-xl px-5 py-5 mt-6">
                        <div className="flex flex-row ">
                          <p className="font-medium text-black">
                            Client Information -
                          </p>
                          <div className="px-2 py-[2px] bg-[#1E293B] rounded-md flex justify-center ml-[5px] ">
                            <p className="font-medium text-white  text-[12px]">
                              {formData.step2.clientType}
                            </p>
                          </div>
                        </div>

                        <div className="flex flew-row justify-between mt-4 flex-wrap">
                          <div className="w-full flex flex-row justify-between">
                            <p className="text-black/50 font-medium w-[30%] text-center">
                              {"Client Name"}
                            </p>
                            <p className="text-black/50 font-medium w-[30%] text-center">
                              {"Phone Number"}
                            </p>
                            <p className="text-black/50 font-medium w-[30%] text-center">
                              {"Email"}
                            </p>
                          </div>
                          {formData.step2.clientinfo.map((item, index) => {
                            const contact = getContactById(item);
                            return (
                              <div className="w-full flex flex-row justify-between mt-2">
                                <p className=" text-sm font-semibold text-black w-[30%] text-center">
                                  {contact.name || "-"}
                                </p>
                                <p className=" text-sm font-semibold text-black w-[30%] text-center">
                                  {contact.phone
                                    ? formatPhone(contact.phone)
                                    : "-"}
                                </p>
                                <p className=" text-sm font-semibold text-black w-[30%] text-center">
                                  {contact.email || "-"}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div className="bg-gray-100  rounded-xl px-5 py-5 mt-6">
                        <p className="font-medium text-black">
                          Agent & Property
                        </p>

                        <div className="flex flew-row gap-x-[2%] mt-4 flex-wrap">
                          {stats("Team Lead Name", formData.step3.teamleadName)}
                          {formData.step3.splittype != "NoSplit" &&
                            stats(
                              formData.step3.splittype == "Referral"
                                ? "Referral Name"
                                : formData.step3.splittype == "TeamSplit"
                                  ? "Agent Name"
                                  : null,
                              formData.step3.splittype == "Referral"
                                ? formData.step3.thirdpartyagentName
                                : formData.step3.splittype == "TeamSplit"
                                  ? formData.step3.agentName
                                  : null,
                            )}
                          {stats("Split Type", formData.step3.splittype)}
                          {stats(
                            "Closing Date",
                            formatDate(formData.step1.closingdate),
                          )}
                          {stats(
                            "Financing Deadline",
                            formatDate(formData.step1.financingDeadline),
                          )}
                          {stats(
                            "Inspection Deadline",
                            formData.step1.inspectionDeadline,
                          )}
                          {stats(
                            "Broker Admin Fee",
                            formatCurrency(formData.step3.brokeradminfee),
                          )}
                          {stats(
                            "Property Address",
                            formData.step1.propertyaddress,
                          )}
                          {stats(
                            "Lead Source",
                            formData.step3.leadsource.abbreviation
                              ? formData.step3.leadsource.abbreviation
                              : "N/A",
                          )}
                        </div>
                      </div>

                      <div className="bg-gradient-to-r  from-[#0f172a] to-[#1E293B]  rounded-xl px-5 py-5 mt-6">
                        <p className="font-medium text-white">Commission</p>

                        <div className="flex flew-row justify-between mt-4 flex-wrap">
                          {stats3(
                            "Total Commission",
                            formData.step4.totalCommissionamount,
                          )}
                          {stats3(
                            "Team Lead Commission",
                            formData.step4.teamleadCommissionamount,
                          )}
                          {formData.step4.bankcommission > 0 &&
                            stats3(
                              "Coldwell Banker Realty Commission",
                              formData.step4.bankcommission,
                            )}
                          {formData.step4.leadsourceCommissionamount > 0 &&
                            stats3(
                              "Lead Source Commission",
                              formData.step4.leadsourceCommissionamount,
                            )}
                          {formData.step3.splittype != "NoSplit" &&
                            stats3(
                              formData.step3.splittype == "Referral"
                                ? "Referral Commission"
                                : formData.step3.splittype == "TeamSplit"
                                  ? "Agent Commission"
                                  : null,
                              formData.step3.splittype == "Referral"
                                ? formData.step4.thirdpartyagentcommissionamount
                                : formData.step3.splittype == "TeamSplit"
                                  ? formData.step4.agentCommissionamount
                                  : null,
                            )}
                          {formData.step3.splittype == "Referral" &&
                            formData.step4.agentCommissionamount > 0 &&
                            stats3(
                              "Agent Commission",
                              formData.step4.agentCommissionamount,
                            )}
                        </div>
                      </div>

                      <div className="flex items-center gap-2 mt-4">
                        <input
                          type="checkbox"
                          id="confirm"
                          checked={confirm}
                          onChange={(e) => {
                            setconfirm(e.target.checked);
                          }}
                        />
                        <label htmlFor="confirm">
                          I confirm all details are accurate.
                        </label>
                      </div>
                    </div>
                  )}
              </div>

              {/* Navigation Buttons */}
              {/* Navigation Buttons (Fixed at bottom) */}
            </div>
          </div>
          <div className="  h-[10%]  bg-white border-t border-gray-200 px-4 flex  flex-row  justify-between items-center ">
            <button
              onClick={handlePrevious}
              disabled={currentStep === 1}
              className={`px-5 h-[35px] rounded-lg border border-gray-300 hover:bg-gray-100 transition ${
                currentStep === 1 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              Previous
            </button>

            {((user.role == "Admin" ||
              user.role == "Supervisor" ||
              user.role == "Accountant") &&
              currentStep < 5) ||
            (user.role == "Employee" && currentStep < 3) ? (
              <button
                onClick={handleNext}
                className="px-5  h-[35px] bg-[#1E293B] hover:bg-[#1E293B] text-white rounded-lg shadow transition-all"
              >
                Next Step
              </button>
            ) : (
              (() => {
                const SALE_STAGES = ["Under Contract", "Pending", "Closed"];
                const requiresPa =
                  !editdata && SALE_STAGES.includes(step1Data.dealStage);
                // A document run through the AI parser counts as the purchase
                // agreement too: picking a PDF there auto-attaches it, and a
                // parsed result (which survives step navigation) also satisfies
                // the requirement.
                const parsedFromDoc = !!pdfImportState?.result;
                const paAttachOk =
                  !requiresPa || !!attachedPaFile || parsedFromDoc;
                return (
              <button
                disabled={isLoading}
                onClick={async () => {
                  // Ignore extra taps while a submission is already uploading
                  // (photos + purchase agreement can take several seconds).
                  if (isLoading) return;
                  // Tell the user WHAT's missing instead of a silently-dead
                  // button. Both are required before a deal can be submitted.
                  if (!confirm) {
                    toast.error(
                      "Please check “I confirm all details are accurate” before submitting.",
                    );
                    return;
                  }
                  if (!paAttachOk) {
                    toast.error(
                      "Attach the purchase agreement to submit this sale.",
                    );
                    return;
                  }
                  if (
                    user.role == "Admin" ||
                    user.role == "Supervisor" ||
                    user.role === "Accountant"
                  ) {
                    if (editdata) {
                      formData.attachedPaFile = attachedPaFile;
                      onSubmit(formData, true, editdata.createdat);
                    } else {
                      formData.attachedPaFile = attachedPaFile;
                      onSubmit(
                        formData,
                        user.role == "Admin" ||
                          user.role == "Supervisor" ||
                          user.role === "Accountant"
                          ? true
                          : false,
                        seed?.sourceDealId || undefined,
                      );
                    }
                  } else {
                    if (editdata) {
                      let data = { ...formData };
                      data.step3 = step3Data;
                      let newdata = { ...step4Data };
                      /////////////lead source commission/////
                      newdata.leadsourceCommissionamount = (
                        (step4Data.totalCommissionamount / 100) *
                        asNumber(step3Data.leadCommission)
                      ).toFixed(2);

                      /////////////team lead commission/////

                      // newdata.teamleadCommissionamount = (
                      //   (step4Data.takehomecommissionamount / 100) *
                      //   (100 - step3Data.agentCommission)
                      // ).toFixed(2);

                      newdata.teamleadCommissionamount =
                        step3Data.captype == "pre"
                          ? (
                              (step4Data.takehomecommissionamount / 100) *
                              (100 - asNumber(step3Data.agentCommission) - 10)
                            ).toFixed(2)
                          : (
                              (step4Data.takehomecommissionamount / 100) *
                              (100 - asNumber(step3Data.agentCommission))
                            ).toFixed(2);

                      /////////////cold wall bank commission/////
                      newdata.bankcommission = step4Data.bankcommission;

                      /////////////in house agent commission/////

                      newdata.agentCommissionamount = (
                        (step4Data.takehomecommissionamount / 100) *
                        asNumber(step3Data.agentCommission)
                      ).toFixed(2);

                      /////////////thirdparty agent commission/////

                      newdata.thirdpartyagentcommissionamount = (
                        (step4Data.totalCommissionamount / 100) *
                        asNumber(step3Data.thirdpartyagentCommission)
                      ).toFixed(2);
                      const newstep4data = calculatecommission(newdata);
                      data.step4 = newstep4data;

                      data.attachedPaFile = attachedPaFile;
                      onSubmit(data, true, editdata.createdat);
                    } else {
                      let data = { ...formData };
                      data.step3 = step3Data;
                      data.step4 = step4Data;

                      data.attachedPaFile = attachedPaFile;
                      onSubmit(
                        data,
                        user.role == "Admin" ||
                          user.role == "Supervisor" ||
                          user.role === "Accountant"
                          ? true
                          : false,
                        seed?.sourceDealId || undefined,
                      );
                    }
                  }
                }}
                className={`px-5  h-[35px]  ${
                  confirm && paAttachOk
                    ? "bg-[#1E293B] hover:bg-[#1E293B] hover:cursor-pointer"
                    : "bg-gray-500 hover:bg-gray-700"
                } text-white rounded-lg shadow transition-all flex items-center`}
              >
                {editdata
                  ? "Update Deal"
                  : user.role == "Admin" ||
                      user.role == "Supervisor" ||
                      user.role === "Accountant"
                    ? "Submit Deal"
                    : "Submit For Review"}
                {isLoading && (
                  <div role="status" className="pl-3">
                    <svg
                      aria-hidden="true"
                      class="size-5 text-gray-200 animate-spin dark:text-white fill-themeColor"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <span class="sr-only">Loading...</span>
                  </div>
                )}
              </button>
                );
              })()
            )}
          </div>
        </div>
      </div>

      {pickerOpen && (
        <AddClientPicker
          userId={user?.id}
          existingCustomerIds={step2Data.clientinfo.filter((id) => id)}
          onClose={() => setPickerOpen(false)}
          onPick={(contactId) => {
            setPickerOpen(false);
            attachClient(contactId);
          }}
          onCreateNew={() => {
            setPickerOpen(false);
            setCreatingContact(true);
          }}
        />
      )}

      {editingContact && (
        <ContactEditDrawer
          initial={editingContact}
          onClose={() => !contactSaving && setEditingContact(null)}
          onSubmit={handleSaveEditedContact}
          saving={contactSaving}
        />
      )}

      {creatingContact && (
        <ContactEditDrawer
          initial={null}
          onClose={() => !contactSaving && setCreatingContact(false)}
          onSubmit={handleCreateNewContact}
          saving={contactSaving}
        />
      )}
    </>
  );
};

export default AddNewDeal;
